/**
 * Keeps price partition rows aligned with room combination indices when the user
 * checks/unchecks repartition types. Partitions are keyed by combination index
 * (e.g. doubleRoomOptions value), not by row position.
 */
export function mergeHotelPricePartitionsByRoomOptions<
  P extends Record<string, unknown>,
>({
  previousRoomOptionIndices,
  previousPartitions,
  nextRoomOptionIndices,
  createDefaultPartition,
}: {
  previousRoomOptionIndices: number[];
  previousPartitions: P[];
  nextRoomOptionIndices: number[];
  createDefaultPartition: () => P;
}): P[] {
  const map = new Map<number, P>();
  const n = Math.min(
    previousRoomOptionIndices.length,
    previousPartitions.length,
  );
  for (let i = 0; i < n; i++) {
    map.set(previousRoomOptionIndices[i], {
      ...previousPartitions[i],
    } as P);
  }
  return nextRoomOptionIndices.map((optIdx) => {
    const existing = map.get(optIdx);
    return existing !== undefined ? existing : createDefaultPartition();
  });
}

export function hotelPricePartitionArraysEqual<P>(a: P[], b: P[]): boolean {
  if (a.length !== b.length) return false;
  return a.every((item, i) => JSON.stringify(item) === JSON.stringify(b[i]));
}
